import axios, { Method } from 'axios';
import cookies from 'js-cookie';

class Request {
	private token: string | null;

	private monthNumber: number | null;

	constructor() {
		this.token = null;
		this.monthNumber = null;

		axios.interceptors.response.use(
			(response) => {
				return response;
			},
			(error) => {
				this.handleErrors(error);
				return Promise.reject(error);
			},
		);
	}

	setToken = (token: string) => {
		this.token = token;
	};

	removeToken = () => {
		this.token = null;
	};

	setMonth = (monthNumber: number | null) => {
		this.monthNumber = monthNumber;
	};

	get = (
		url: string,
		data = {},
		customHeaders = {},
		customContentType = null,
		noAuthorization = false,
	) => {
		return this.requestAxios(
			'get',
			this.getApiUrl(url),
			data,
			customContentType,
			customHeaders,
			noAuthorization,
		);
	};

	post = (
		url: string,
		data = {},
		customHeaders = {},
		customContentType = null,
		noAuthorization = false,
	) => {
		return this.requestAxios(
			'post',
			this.getApiUrl(url),
			data,
			customContentType,
			customHeaders,
			noAuthorization,
		);
	};

	delete = (
		url: string,
		data = {},
		customHeaders = {},
		customContentType = null,
		noAuthorization = false,
	) => {
		return this.requestAxios(
			'delete',
			this.getApiUrl(url),
			data,
			customContentType,
			customHeaders,
			noAuthorization,
		);
	};

	put = (
		url: string,
		data = {},
		customHeaders = {},
		customContentType = null,
		noAuthorization = false,
	) => {
		return this.requestAxios(
			'put',
			this.getApiUrl(url),
			data,
			customContentType,
			customHeaders,
			noAuthorization,
		);
	};

	private requestAxios = (
		method: Method,
		url: string,
		data: any,
		customContentType = null,
		customHeaders = {},
		noAuthorization = false,
	) => {
		return axios({
			url,
			method,
			headers: this.getHeaders(
				customContentType,
				customHeaders,
				noAuthorization,
			),
			[['post', 'delete', 'put'].includes(method) ? 'data' : 'params']: {
				...data,
				...(this.monthNumber ? { month: this.monthNumber } : {}),
			},
		});
	};

	private getHeaders = (
		customContentType = null,
		customHeaders = {},
		noAuthorization = false,
	) => {
		return {
			'Content-Type':
				customContentType || 'application/json; charset=utf-8',
			...(this.token && !noAuthorization
				? { Authorization: `Bearer ${this.token}` }
				: {}),
			...(customHeaders || {}),
		};
	};

	private getApiUrl = (url: string) => {
		if (url.includes('https://') || url.includes('http://')) return url;
		return `${
			process.env.NODE_ENV === 'production'
				? process.env.REACT_APP_BASE_API_URL
				: 'http://192.168.0.115:4020'
		}${url}`;
	};

	private handleErrors = (error: any) => {
		switch (error.response.status) {
			case 500:
				throw new Error('500 error');
			case 429:
				throw new Error('429 error');
			case 401:
				cookies.remove('jwt');
				window.replace('/login');
				break;
			default:
				break;
		}
		return false;
	};
}

export default new Request();
